export default __webpack_public_path__ + "static/media/ProfileIcon.cc09ee1d.svg";